const productInfo = {
  ret: 0,
  data: {
    resp: {
      retCode: 0,
      vipMemberProductList: [
        {
          productID: '000111222',
          offerID: '111000222',
          productName: '1个月',
          originalPrice: 25,
          currentPrice: 15,
          productType: 1,
          isDefault: true,
          month: 1,
          storage: 1024,
          serviceID: '111222333',
          oldversion: 0,
          newversion: 0
        },
        {
          productID: '444555666',
          offerID: '555444666',
          productName: '6个月',
          originalPrice: 150,
          currentPrice: 70,
          productType: 1,
          isDefault: true,
          month: 6,
          storage: 1024,
          serviceID: '666555444',
          oldversion: 0,
          newversion: 0
        },
        {
          productID: 'android_one_year',
          offerID: '555444666',
          productName: '12个月放心用',
          originalPrice: 300,
          currentPrice: 108,
          productType: 1,
          isDefault: true,
          month: 12,
          storage: 3,
          serviceID: '666555444',
          oldversion: 0,
          newversion: 0
        }
      ],
      vipInfoProfile:
			{
			  vipLevel: 1,
			  expireDate: 0,
			  isAutoRenew: true,
			  totalStorage: 0,
			  currentStorage: 0,
			  totalScanCount: 0,
			  currentScanCount: 0,
			  refreshDate: 0,
			  isCalculateHistoryData: 0,
			  currentStorageForA: 0,
			  totalStorageForA: 0,
			  c4bExpireDate: 0,
			  c4bWebExpireDate: 0
			}
    }
  }
};
const bonusList = {
  success: true,
  code: 0,
  result:
	{
	  timestamp: 1572519619303,
	  bonus:
			[
			  { id: 8, title: '出境最高减2000元', s_logo: 'http://webcdn.m.qq.com/captureAvalon/c6fc5ca2679386386cefe6b68baacafe1572514915591.png', desc: '', entry: 2, type: 1, view_id: 0, jump_link: 'https://webcdn.m.qq.com/webcdn/activity/webapp_pim_vip_beta/index.html?mid=8#/bonus' },
			  { id: 7, title: '700元文创优惠券', s_logo: 'http://webcdn.m.qq.com/captureAvalon/4df3f5891b545fd163e42a51ee825b131572514982056.png', desc: '免门票逛博物馆', entry: 2, type: 2, view_id: 0, jump_link: 'https://webcdn.m.qq.com/webcdn/activity/webapp_pim_vip_beta/index.html?mid=7#/bonus' },
			  { id: 6, title: '咪咕阅读听书', s_logo: 'http://webcdn.m.qq.com/captureAvalon/111673c3fb8b13da3f339d75c7a565ab1572513590744.png', desc: '听书VIP月卡1份', entry: 2, type: 2, view_id: 0, jump_link: 'https://webcdn.m.qq.com/webcdn/activity/webapp_pim_vip_beta/index.html?mid=6#/bonus' }
			]
	}
};
const bonus = {
  title: '书旗小说', // 详情页标题
  // detail: "30天VIP",//详情页描述
  detail: '使用说明^1.3G空间优惠券每个用户限领一次；^2.每个优惠码对应一次体验券，请务必收藏好您的优惠码。如有泄漏，导致被他人兑换，该结果由用户本人承担；^3.仅限本人兑换使用，严禁售卖，转让；^4.您的啦啦阿拉零零落落零零落落零零落落零零落落零零落落零零落落；^5.仅限本人兑换使用，严禁售卖，转让；^6.您的啦啦阿拉零零落落零零落落零零落落零零落落零零落落零零落落',
  btn: '领取', // 详情页按钮
  b_logo: 'http://webcdn.m.qq.com/captureAvalon/3432912c1cadbcc4cb9688953e4e3397.png', // 详情页大图
  coupon_link: 'https://activity.m.duiba.com.cn/hdtool/index?ut_sk=1.WUqYp5aTdp8DAKxGIqVqYqpd_21380790_1557818019683'
};
const vipRights = [
  {
    title: '通讯录特权',
    type: 'contact',
    rights: [
      { text: '时光机', img: require('@/assets/right-1/1.png') },
      { text: '回收站', img: require('@/assets/right-1/2.png') },
      { text: '批量导入联系人', img: require('@/assets/right-1/3.png') },
      { text: '尊贵标识', img: require('@/assets/right-1/4.png') },
    ],
    info: [
      {
        title: '50次备份记录',
        src: require('@/assets/info-1/1.png'),
        list: [
          '普通用户仅可保存最近10次历史备份记录',
          'VIP会员可保存最近50次历史备份记录',
          '使用时光机为你随时恢复历史备份'
        ]
      },
      {
        title: '回收站号码永久保存',
        src: require('@/assets/info-1/2.png'),
        list: [
          '普通用户回收站联系人仅可保存30天',
          'VIP会员回收站联系人可永久保存',
          '使用回收站可以随时恢复已删除的联系人'
        ]
      },
      {
        title: '批量导入联系人到通讯录',
        src: require('@/assets/info-1/3.png'),
        list: [
          '在电脑端打开ic.qq.com，可使用批量导入联系人功能',
          '支持使用xls等格式一次导入上万个联系人至云端通讯录',
          '再使用手机版同步助手一键同步至手机通讯录'
        ]
      },
      {
        title: '尊贵标识',
        src: require('@/assets/info-1/4.png'),
        list: ['会员尊享VIP身份标识', '黑金会员卡，彰显尊贵身份']
      }
    ]
  },
  {
    title: '文件特权',
    type: 'file',
    rights: [
      { text: '3G云空间', img: require('@/assets/right-2/1.png') },
      { text: '大文件备份', img: require('@/assets/right-2/2.png') },
      { text: '极致云安全', img: require('@/assets/right-2/3.png') },
    ],
    info: [
      {
        title: '超大云空间',
        src: require('@/assets/info-2/1.png'),
        list: [
          '普通用户可用云空间为500MB，可存500份文档',
          'VIP会员可用云空间3GB，可存3000份文件'
        ]
      },
      {
        title: '大文件备份特权',
        src: require('@/assets/info-2/2.png'),
        list: [
          '普通用户文件备份时仅支持备份30MB以下文件',
          'VIP会员可备份任意大小的文件'
        ]
      },
      {
        title: '极致云安全',
        src: require('@/assets/info-2/3.png'),
        list: [
          'VIP会员数据尊享三重加密存储',
          '五级资料隔离存储彻底保护你的数据安全'
        ]
      },
    ]
  },
  {
    title: '格式转换',
    type: 'format',
    rights: [
      { text: 'PDF转Word', img: require('@/assets/right-3/1.png') },
      { text: 'PDF转PPT', img: require('@/assets/right-3/2.png') },
      { text: 'PDF转Excel', img: require('@/assets/right-3/3.png') },
      { text: 'PDF转图片', img: require('@/assets/right-3/4.png') },
      { text: 'Word转PDF', img: require('@/assets/right-3/5.png') },
      { text: 'PPT转PDF', img: require('@/assets/right-3/6.png') },
      { text: 'Excel转PDF', img: require('@/assets/right-3/7.png') }
    ],
    info: [
      {
        title: 'PDF转Word',
        src: require('@/assets/info-3/1.png'),
        list: [
          '将PDF转换为Word，转换完成后可直接复制和编辑内容',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'PDF转PPT',
        src: require('@/assets/info-3/2.png'),
        list: [
          '将PDF转换为PPT，转换完成后可直接复制和编辑内容',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'PDF转Excel',
        src: require('@/assets/info-3/3.png'),
        list: [
          '将PDF转换为Excel，转换完成后可直接复制和编辑内容',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'PDF转图片',
        src: require('@/assets/info-3/4.png'),
        list: [
          '将PDF转换为图片，方便文件分享',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'Word转PDF',
        src: require('@/assets/info-3/5.png'),
        list: [
          '将Word转换为PDF，方便文件阅读和分享',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'PPT转PDF',
        src: require('@/assets/info-3/6.png'),
        list: [
          '将PPT转换为PDF，方便文件阅读和分享',
          '云端自动转换，完成后立即提醒'
        ]
      },
      {
        title: 'Excel转PDF',
        src: require('@/assets/info-3/7.png'),
        list: [
          '将Excel转换为PDF，方便文件阅读和分享',
          '云端自动转换，完成后立即提醒'
        ]
      },
    ]
  },
];
const trackMap = {
  userShow: 35983, //  普通用户购买界面曝光
  userChoose1: 35984, //  普通用户选择1个月套餐进行购买
  userChoose3: 35985, // 普通用户选择3个月套餐进行购买
  userChoose12: 35986, // 普通用户选择12个月套餐进行购买
  vipShow: 35987, // 会员购买界面曝光
  vipChoose1: 35988, // 会员选择1个月套餐进行续费
  vipChoose3: 35989, // 会员选择3个月套餐进行续费
  vipChoose12: 35990, // 会员选择12个月套餐进行续费
  showAll: 36106, // 总曝光
  allChoose1: 36107, // 选择1个月进行购买(普通用户+会员)
  allChoose3: 36108, // 选择3个月进行购买(普通用户+会员)
  allChoose12: 36109, // 选择12个月进行购买(普通用户+会员)
  choosePay: 36158, // 选择套餐进行购买（普通用户+会员）
  vipChoosePay: 36156, // 会员选择套餐进行购买
  userChoosePay: 36154, // 普通用户选择套餐进行购买
  clickBonusTab: 36913, // 点击福利券tab
  clickBonus: 36914, // 点击福利券tab下面的任意一张券 ，字符串统计点，上报券的名字
};
const accountInfo = {
  platform: 'android',
  guid: '03023017101816425400016543111331',
  imei: '861414033020083',
  lc: 'ABCDEFGHIJKLMNTEST',
  buildNo: 254000,
  // versioncode: 301,
  mainAccount: {
    qqLoginkey: {
      key: ''
    },
    state: 'online',
    uin: '362952044',
    callbackId: '10',
    qq_unionid: 'UID_35BFDD0D06DCA158C615D49D0D7C9575',
    qq_uin: '362952044',
    qq_nickname: '猪猪',
    nickname: '猪猪',
    user_id: '362952044',
    ret: 0,
    accountId: 'UID_35BFDD0D06DCA158C615D49D0D7C9575',
    qq_openid: '9F6BB6E853723871FDA7B79F80ECAF15',
    token: 'P0rXB2e4kBbE4nbnhdkxbGWnYBDOIq6diWuvNT+aDwLEVnNSONMoX2d24HgVGuW+6NOCVXrYQfQ/FY+LaremREIPpbCyQ6dIug36F9H4RWk=',
    err_msg: 'ok',
    qq_faceUrl: '',
    wx_faceUrl: '',
    faceUrl: '',
    sessionId: '1',
    access_token: '7A40509409C6CC99BDE8A55B06E73244'
  },
  galleryAccount: {
    remainSeconds: 448710,
    ret: 0,
    total: 3221225472,
    used: 1215233179
  }
};

export default {
  productInfo,
  bonusList,
  bonus,
  accountInfo,
  vipRights,
  trackMap
};
